import ServiceFactory from './service-factory'

/**
 * Gateway Service for polling routines. This calls through to nested services that implement a Status interface.
 * This allows dynamic method access for the poller.
 *
 * @export StatusService
 * @class StatusService
 */
export default class StatusService {

    /**
     * Check the status of the improvements calculation for an address ID.
     *
     * @param {number} addressId
     * @returns {Promise<ServiceOperation>} The operation result.
     * @memberof StatusService
     */
    async checkAnalysisCalculationAsync(addressId) {
        const service = ServiceFactory.improvement()
        return await service.checkAnalysisCalculationAsync(addressId)
    }

    /**
     * Check the status of base metrics data for an address ID.
     *
     * @param {number} addressId
     * @returns {Promise<ServiceOperation>} The operation result.
     * @memberof StatusService
     */
    async checkBaseStatisticsAsync(addressId) {
        const service = ServiceFactory.saving()
        return await service.checkBaseStatisticsAsync(addressId)
    }
}
